// https://app.growthbook.io/features/pen-3951_v2
export const GOOGLE_EMAIL_CAPTURE_FLAG = 'pen-3951_v2'
